import {
  LuBuilding2,
  LuPencilRuler,
  LuUsers,
  LuWorkflow,
} from 'react-icons/lu';

const iconProps = {
  size: 34,
  strokeWidth: 2.2,
};

export const WhoWeAreIcon = () => <LuUsers {...iconProps} />;

export const RoleIcon = () => <LuWorkflow {...iconProps} />;

export const ResponsibilityIcon = () => <LuPencilRuler {...iconProps} />;

export const ProjectsIcon = () => <LuBuilding2 {...iconProps} />;
